import React, { useState, useRef, useEffect, useMemo } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
// material ui
import {
    Container,
    Stack,
    Typography,
    Grid,
    TextField,
    InputAdornment,
    CardContent,
    IconButton,
    Tooltip,
    OutlinedInput,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    Chip
} from '@mui/material';
import {
    Search as SearchIcon,
    SendTwoTone as SendTwoToneIcon,
    DriveFileRenameOutlineOutlined as DriveFileRenameOutlineOutlinedIcon,
    AddCircleTwoTone as AddCircleTwoTone
} from '@mui/icons-material';

//import projects
import MainCard from 'ui-component/cards/MainCard';
import SubCard from 'ui-component/cards/SubCard';
import ConversationBubble from './ConversationBubble';
import { sendFeedback } from './conversationApi';
import ConversationTile from './ConversationTile';
import { addQuery, fetchAnswer, selectQueries, selectStatus, updateQuery } from './conversationSlice';
import { selectConversations, setConversations } from './preferences/preferenceSlice';
import { setConversation, updateConversationId } from './conversationSlice';
import { store } from 'store';
import apiSlice from 'store/slices/apiSlice';

//react-redux
import { useDispatch, useSelector } from 'react-redux';

//styles
import { useTheme } from '@mui/material/styles';

//third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import ClipLoader from 'react-spinners/ClipLoader';
import Slider from 'react-slick';

// Internal variant
const modelOption = [
    { name: 'gpt-4', label: 'gpt-4' },
    { name: 'gpt-4-0613', label: 'gpt-4-0613' },
    { name: 'gpt-4-32k', label: 'gpt-4-32k' },
    { name: 'gpt-4-32k-0613', label: 'gpt-4-32k-0613' },
    // {"name": "gpt-4-turbo", "label": "gpt-4-turbo"},
    // {"name": "gpt-3-turbo","label":"gpt-3-turbo"},
    // {"name": "gpt-3-turbo-0613","label":"gpt-3-turbo-0613"},
    // {"name": "gpt-3-turbo-16k","label":"gpt-3-turbo-16k"},
    // {"name": "gpt-3-turbo-16k-0613","label":"gpt-3-turbo-16k-0613"},
    // {"name": "gpt-3-turbo-long","label":"gpt-3-turbo-long"},
    // {"name": "code-davinci-002","label":"code-davinci-002"},
    // {"name": "text-ada-001","label":"text-ada-001"},
    // {"name": "text-babbage-001","label":"text-babbage-001"},
    // {"name": "text-curie-001","label":"text-curie-001"},
    // {"name": "text-davinci-002","label":"text-davinci-002"},
    // {"name": "text-davinci-003","label":"text-davinci-003"},
    { name: 'gpt-4-1106', label: 'gpt-4-1106 (trả phí)' }
];

const lengthOption = [
    { name: 'auto', label: 'Tự động' },
    { name: 'short', label: 'Ngắn' },
    { name: 'medium', label: 'Trung bình' },
    { name: 'long', label: 'Dài' }
];

const formatOption = [
    { name: 'auto', label: 'Tự động' },
    { name: 'emoji', label: 'Biểu tượng cảm xúc' },
    { name: 'outline', label: 'Dàn ý' },
    { name: 'paragraph', label: 'Đoạn văn' },
    { name: 'bullet', label: 'Gạch đầu dòng' },
    { name: 'summary', label: 'Tóm tắt' },
    { name: 'article', label: 'Bài báo' },
    { name: 'socialMediaPost', label: 'Bài đăng mạng xã hội' },
    { name: 'presentation', label: 'Bài thuyết trình' },
    { name: 'report', label: 'Báo cáo' },
    { name: 'documentCompilation', label: 'Biên soạn tài liệu' },
    { name: 'comment', label: 'Bình luận' },
    { name: 'blog', label: 'Blog' },
    { name: 'customerSupport', label: 'Chăm sóc khách hàng' },
    { name: 'campaign', label: 'Chiến dịch' },
    { name: 'email', label: 'Email' },
    { name: 'facebook', label: 'Facebook' },
    { name: 'guide', label: 'Hướng dẫn' },
    { name: 'message', label: 'Tin nhắn' },
    { name: 'idea', label: 'Ý tưởng' },
    { name: 'youtube', label: 'YouTube' }
];

const styleOption = [
    { name: 'auto', label: 'Tự động' },
    { name: 'impactful', label: 'Ảnh hưởng' },
    { name: 'accurate', label: 'Chính xác' },
    { name: 'professional', label: 'Chuyên nghiệp' },
    { name: 'persuasive', label: 'Có sức thuyết phục' },
    { name: 'motivational', label: 'Động viên' },
    { name: 'approachable', label: 'Gần gũi' },
    { name: 'simple', label: 'Giản dị' },
    { name: 'humorous', label: 'Hài hước' },
    { name: 'engaging', label: 'Hấp dẫn' },
    { name: 'academic', label: 'Học thuật' },
    { name: 'determined', label: 'Quyết đoán' },
    { name: 'clear', label: 'Rõ ràng' },
    { name: 'creative', label: 'Sáng tạo' },
    { name: 'friendly', label: 'Thân thiện' },
    { name: 'informative', label: 'Cung cấp thông tin' },
    { name: 'persuasive', label: 'Thuyết phục' },
    { name: 'organized', label: 'Tổ chức' },
    { name: 'formal', label: 'Trang trọng' },
    { name: 'interactive', label: 'Tương tác' },
    { name: 'natural', label: 'Tự nhiên' }
];

const userObjectOption = [
    { name: 'endUser', label: 'Người dùng cuối' },
    { name: 'customerSupport', label: 'Chăm sóc khách hàng' },
    { name: 'marketingSpecialist', label: 'Chuyên viên tiếp thị' },
    { name: 'strategicPartner', label: 'Đối tác chiến lược' },
    { name: 'teacherInstructor', label: 'Giáo viên/ Giảng viên' },
    { name: 'student', label: 'Học sinh/ Sinh viên' },
    { name: 'customer', label: 'Khách hàng' },
    { name: 'seniorLeader', label: 'Lãnh đạo cấp cao' },
    { name: 'basicUser', label: 'Người dùng cơ bản' },
    { name: 'contentEditor', label: 'Biên tập viên nội dung' },
    { name: 'researcher', label: 'Nhà nghiên cứu' },
    { name: 'dataAnalyst', label: 'Nhà phân tích dữ liệu' },
    { name: 'salesStaff', label: 'Nhân viên bán hàng' },
    { name: 'developer', label: 'Phát triển viên' },
    { name: 'softwareDeveloper', label: 'Phát triển viên phần mềm' },
    { name: 'projectManager', label: 'Quản lý trợ lý' },
    { name: 'systemAdministrator', label: 'Quản trị viên hệ thống' }
];

const languageOption = [
    { name: 'default', label: 'Tiếng Việt (mặc định)' },
    { name: 'english', label: 'Tiếng Anh' },
    { name: 'korean', label: 'Tiếng Hàn' },
    { name: 'japanese', label: 'Tiếng Nhật' },
    { name: 'chineseSimplified', label: 'Tiếng Trung (Giản thể)' }
];

//style
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
        }
    }
};

const SilderSettings = {
    className: 'slider variable-width',
    dots: false,
    infinite: false,
    swipeToSlide: true,
    variableWidth: true
};

export default function Template({ data, title, options, project, personaRole }) {
    //config
    const dispatch = useDispatch();
    const navigate = useNavigate();

    //theme
    const theme = useTheme();
    //ref
    const chatRef = useRef(null);
    const endMessageRef = useRef(null);
    const scrollRefChat = useRef(null);
    //state for container
    const [searchValue, setSearchValue] = useState('');
    const [filteredData, setFilteredData] = useState(data);
    const [subTopic, setSubTopic] = useState(options[0]);
    const [isPrompt, setPrompt] = useState(false);
    const [tagClicked, setTagClicked] = useState('');

    //state for chatgpt status
    const [message, setMessage] = useState('');
    const [scrollEl, setScrollEl] = useState();
    const [template, setTemplate] = useState({
        model: 'gpt-4',
        length: 'auto',
        format: 'auto',
        style: 'auto',
        userObject: 'endUser',
        language: 'default'
    });

    //state redux
    const conversations = useSelector(selectConversations);
    const queries = useSelector(selectQueries);
    const status = useSelector(selectStatus);

    //prepare data when first load and some side effect
    useEffect(() => {
        dispatch(setConversation([])); // Return an empty conversation when the topic changes
        dispatch(
            updateConversationId({
                query: { conversationId: null }
            })
        );
    }, [title]);

    // origin variant
    const tags = [
        ...new Set(
            data
                .filter((data) => data.sub_topic.trim().toLowerCase() === subTopic.trim().toLowerCase())
                .flatMap((data) => data.tags.split(',').map((tag) => tag.trim()))
        )
    ];

    const scrollIntoViewWithMargin = () => {
        const element = chatRef.current;
        if (element) {
            const topPosition = element?.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: topPosition - 80, // Trừ đi 80px
                behavior: 'smooth'
            });
        }
    };

    //actions
    const handleSearch = (value) => {
        setSearchValue(value);

        // Filter data based on the search value
        const filtered = data.filter((item) => item.content.toLowerCase().includes(value.toLowerCase()));

        // Set the filtered data
        setFilteredData(filtered);
        // setSubTopic('');
    };

    const handleSelectChange = (event) => {
        const { name, value } = event.target;
        setTemplate((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleTagClick = (e, tag) => {
        if (e.target.innerText === tagClicked) {
            setTagClicked('');
            setFilteredData(data.filter((data) => data.sub_topic.trim().toLowerCase() === subTopic.trim().toLowerCase()));
        } else {
            setTagClicked(tag);
            setFilteredData(data.filter((data) => data.tags.includes(tag.trim())));
        }
    };

    const handleDeleteConversation = (id) => {
        store
            .dispatch(apiSlice.endpoints.deleteConversation.initiate(id))
            .then(() => {
                fetchConversations(project);
                dispatch(setConversation([]));
                dispatch(
                    updateConversationId({
                        query: { conversationId: null }
                    })
                );
                navigate('/workspace/' + project);
            })
            .catch((error) => console.error(error));
    };

    const handleQuestion = (question, model) => {
        question = question.trim();
        const modified_question =
            personaRole +
            '***' +
            question.trim() +
            '***' +
            'ngôn ngữ: ' +
            languageOption.find((data) => data.name === template.language).label +
            ', độ dài: ' +
            lengthOption.find((data) => data.name === template.length).label +
            ', được định dạng thành: ' +
            formatOption.find((data) => data.name === template.format).label +
            ', với văn phong: ' +
            styleOption.find((data) => data.name === template.style).label +
            ', đối tượng sử dụng là: ' +
            userObjectOption.find((data) => data.name === template.userObject).label;
        // console.log(modified_question);
        // console.log(model['name'])
        if (question === '') return;
        dispatch(addQuery({ prompt: modified_question }));
        dispatch(fetchAnswer({ question: modified_question, model: model, project }));
    };

    const handleFeedback = (query, feedback, index) => {
        const prevFeedback = query.feedback;
        dispatch(updateQuery({ index, query: { feedback } }));
        sendFeedback(query.prompt, query.response, feedback).catch(() => {
            dispatch(updateQuery({ index, query: { feedback: prevFeedback } }));
        });
    };

    useEffect(() => {
        fetchConversations(project);
    }, []);

    useEffect(() => {
        if (!conversations) {
            fetchConversations(project);
        }
    }, [conversations, dispatch]);

    useMemo(() => {
        if (scrollEl) {
            scrollEl.scrollTop = scrollRefChat?.current?.offsetTop;
        }
    }, [scrollEl, queries]);

    async function fetchConversations(project) {
        try {
            const res = await store.dispatch(
                apiSlice.endpoints.getConversationsList.initiate({
                    project,
                    user_token: localStorage.getItem('user_token')
                })
            );
            if (res.data) dispatch(setConversations(res.data));
        } catch (error) {
            console.error('Failed to fetch conversations: ', error);
        }
    }

    const handleConversationClick = (index) => {
        store
            .dispatch(apiSlice.endpoints.getConversation.initiate(index))
            .then((res) => {
                if (!res.data) return;
                navigate('/workspace/' + project);
                dispatch(setConversation(res.data));
                dispatch(
                    updateConversationId({
                        query: { conversationId: index }
                    })
                );
            });
    };

    async function updateConversationName(updatedConversation) {
        try {
            const res = await store.dispatch(
                apiSlice.endpoints.updateConversation.initiate({
                    id: updatedConversation.id,
                    ...updatedConversation
                })
            );
            if (res?.data) {
                navigate('/workspace/' + project);
                fetchConversations(project);
            }
        } catch (err) {
            console.error(err);
        }
    }

    const prepResponseView = (query, index) => {
        let responseView;
        if (query.error) {
            responseView = (
                <ConversationBubble
                    ref={endMessageRef}
                    className={`${index === queries.length - 1 ? 'mb-2' : 'mb-2'}`}
                    key={`${index}ERROR`}
                    message={query.error}
                    type="ERROR"
                ></ConversationBubble>
            );
        } else if (query.response) {
            responseView = (
                <ConversationBubble
                    ref={endMessageRef}
                    className={`${index === queries.length - 1 ? 'mb-2' : 'mb-2'}`}
                    key={`${index}ANSWER`}
                    message={query.response}
                    type={'ANSWER'}
                    sources={query.sources}
                    feedback={query.feedback}
                    handleFeedback={(feedback) => handleFeedback(query, feedback, index)}
                    isTheLast={index === queries.length - 1}
                ></ConversationBubble>
            );
        }
        return responseView;
    };

    return (
        <MainCard
            className="h-100"
            contentSX={{ padding: 0 }}
            headersx={{ padding: '10px' }}
            sx={{
                bgcolor: 'white'
            }}
            style={{
                minHeight: 800
            }}
        >
            <Container>
                <Stack
                    direction="column"
                    spacing={2}
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', paddingTop: '16px' }}
                >
                    <Typography variant="h1" color={theme.palette.main.items}>
                        {title}
                    </Typography>
                    <Typography variant="body1" maxWidth="md">
                        "Khám phá thông tin chi tiết từ các lĩnh vực khác nhau - chọn chủ đề, điều chỉnh prompt theo ý muốn, và trải nghiệm
                        sự thông minh của chatbot trong việc cung cấp câu trả lời chi tiết tại đây!"
                    </Typography>
                </Stack>
                <Stack spacing={2} direction="row" sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center', paddingTop: 2 }}>
                    <FormControl sx={{ width: 300 }} size="small">
                        <InputLabel id="slect-model">Chủ đề</InputLabel>
                        <Select
                            labelId="slect-model"
                            id="demo-select-small"
                            name="model"
                            value={subTopic}
                            label="Chủ đề"
                            onChange={(e) => {
                                setSubTopic(e.target.value);
                                setTagClicked('');
                                setFilteredData(
                                    data.filter((data) => data.sub_topic.trim().toLowerCase() === e.target.value.trim().toLowerCase())
                                );
                            }}
                        >
                            {options.map((data, index) => (
                                <MenuItem key={index} value={data}>
                                    {data}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                        placeholder="Tìm kiếm"
                        size="small"
                        value={searchValue}
                        onChange={(e) => {
                            handleSearch(e.target.value);
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            )
                        }}
                    ></TextField>
                </Stack>
                <Grid container spacing={2} sx={{ paddingTop: '16px' }}>
                    <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography variant="h6">Tags:</Typography>
                    </Grid>
                    <Grid item xs={11} sx={{ paddingRight: '5%' }}>
                        <Slider {...SilderSettings}>
                            {tags.map((tag, index) => (
                                <div key={index} sx={{ padding: 1 }}>
                                    <Chip
                                        sx={{ cursor: 'pointer', marginRight: '4px' }}
                                        onClick={(e) => {
                                            handleTagClick(e, tag);
                                        }}
                                        label={tag}
                                        color="primary"
                                        variant={tagClicked === tag ? 'filled' : 'outlined'}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </Grid>
                </Grid>
                <Stack
                    spacing={2}
                    direction="column"
                    sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center', paddingTop: 2 }}
                >
                    <SubCard sx={{ height: '460px', overflowY: 'auto', width: '100%' }}>
                        {filteredData?.map(
                            (data, index) =>
                                data.sub_topic.trim().toLowerCase() === subTopic.trim().toLowerCase() && (
                                    <SubCard sx={{ width: '100%', marginTop: 2, marginBottom: 2 }} key={index}>
                                        <Grid container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <Grid item xs={11}>
                                                <Typography variant="h5">{data.content}</Typography>
                                            </Grid>
                                            <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'right' }}>
                                                <Tooltip title="Áp dụng">
                                                    <IconButton
                                                        onClick={() => {
                                                            scrollIntoViewWithMargin();
                                                            setMessage(data.content);
                                                        }}
                                                    >
                                                        <DriveFileRenameOutlineOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                )
                        )}
                    </SubCard>
                    <Grid container>
                        <Grid item xs={2.5} sx={{ minHeight: '100%', overflowY: 'auto', padding: '0px' }}>
                            <SubCard
                                sx={{ minHeight: '100%', padding: 0, overflowY: 'auto', height: '400px' }}
                                headersx={{ textAlign: 'center' }}
                                title={
                                    <Grid item xs={12} textAlign="center">
                                        <NavLink to={'/workspace/' + project}>
                                            <Button
                                                variant="contained"
                                                sx={{ padding: 1, paddingX: 2, backgroundColor: '#156DA2' }}
                                                startIcon={<AddCircleTwoTone />}
                                                onClick={() => {
                                                    dispatch(setConversation([]));
                                                    dispatch(
                                                        updateConversationId({
                                                            query: { conversationId: null }
                                                        })
                                                    );
                                                }}
                                            >
                                                Tin nhắn mới
                                            </Button>
                                        </NavLink>
                                    </Grid>
                                }
                            >
                                {/* <Navigation navOpen={navOpen} setNavOpen={setNavOpen} /> */}
                                <Typography variant="h5">Lịch sử tin nhắn</Typography>
                                {conversations && (
                                    // <div className="conversations-container mb-auto max-h-[25rem] overflow-y-auto">
                                    <div>
                                        {conversations?.map((conversation) => (
                                            <ConversationTile
                                                key={conversation.id}
                                                conversation={conversation}
                                                selectConversation={(id) => handleConversationClick(id)}
                                                onDeleteConversation={(id) => handleDeleteConversation(id)}
                                                onSave={(conversation) => updateConversationName(conversation)}
                                            />
                                        ))}
                                    </div>
                                )}
                            </SubCard>
                        </Grid>
                        <Grid item xs={12} sm={9.5}>
                            <SubCard sx={{ width: '100%' }} ref={chatRef}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Stack direction="row" spacing={1}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={6} sm={4} md={2}>
                                                    <FormControl sx={{ width: '100%' }} size="small">
                                                        <InputLabel id="slect-model">Model</InputLabel>
                                                        <Select
                                                            labelId="slect-model"
                                                            id="demo-select-small"
                                                            name="model"
                                                            value={template.model}
                                                            label="Model"
                                                            onChange={handleSelectChange}
                                                        >
                                                            {modelOption.map((data, index) => (
                                                                <MenuItem key={index} value={data.name}>
                                                                    {data.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={6} sm={4} md={2}>
                                                    <FormControl sx={{ width: '100%' }} size="small">
                                                        <InputLabel id="slect-length">Độ dài</InputLabel>
                                                        <Select
                                                            labelId="slect-length"
                                                            id="demo-select-small"
                                                            name="length"
                                                            value={template.length}
                                                            label="Độ dài"
                                                            onChange={handleSelectChange}
                                                        >
                                                            {lengthOption.map((data, index) => (
                                                                <MenuItem key={index} value={data.name}>
                                                                    {data.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={6} sm={4} md={2}>
                                                    <FormControl sx={{ width: '100%' }} size="small">
                                                        <InputLabel id="slect-format">Định dạng</InputLabel>
                                                        <Select
                                                            labelId="slect-format"
                                                            id="demo-select-small"
                                                            name="format"
                                                            value={template.format}
                                                            label="Định dạng"
                                                            onChange={handleSelectChange}
                                                            MenuProps={MenuProps}
                                                        >
                                                            {formatOption.map((data, index) => (
                                                                <MenuItem key={index} value={data.name}>
                                                                    {data.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={6} sm={4} md={2}>
                                                    <FormControl sx={{ width: '100%' }} size="small">
                                                        <InputLabel id="slect-style">Văn phong</InputLabel>
                                                        <Select
                                                            labelId="slect-style"
                                                            id="demo-select-small"
                                                            name="style"
                                                            value={template.style}
                                                            label="Văn phong"
                                                            onChange={handleSelectChange}
                                                            MenuProps={MenuProps}
                                                        >
                                                            {styleOption.map((data, index) => (
                                                                <MenuItem key={index} value={data.name}>
                                                                    {data.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={6} sm={4} md={2}>
                                                    <FormControl sx={{ width: '100%' }} size="small">
                                                        <InputLabel id="slect-userObject">Đối tượng sử dung</InputLabel>
                                                        <Select
                                                            labelId="slect-userObject"
                                                            id="demo-select-small"
                                                            name="userObject"
                                                            value={template.userObject}
                                                            label="Đối tượng sử dung"
                                                            onChange={handleSelectChange}
                                                            MenuProps={MenuProps}
                                                        >
                                                            {userObjectOption.map((data, index) => (
                                                                <MenuItem key={index} value={data.name}>
                                                                    {data.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={6} sm={4} md={2}>
                                                    <FormControl sx={{ width: '100%' }} size="small">
                                                        <InputLabel id="slect-language">Ngôn ngữ</InputLabel>
                                                        <Select
                                                            labelId="slect-language"
                                                            id="demo-select-small"
                                                            name="language"
                                                            value={template.language}
                                                            label="Ngôn ngữ"
                                                            onChange={handleSelectChange}
                                                        >
                                                            {languageOption.map((data, index) => (
                                                                <MenuItem key={index} value={data.name}>
                                                                    {data.label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Stack>
                                    </Grid>
                                    <PerfectScrollbar
                                        style={{
                                            width: '100%',
                                            height: '400px',
                                            overflowX: 'hidden',
                                            minHeight: '400px'
                                        }}
                                        containerRef={(ref) => {
                                            setScrollEl(ref);
                                        }}
                                    >
                                        <Box>
                                            <CardContent sx={{ width: '100%' }}>
                                                {/* {queries.length > 0 && !hasScrolledToLast && (
                                        <button
                                            onClick={scrollIntoView}
                                            aria-label="scroll to bottom"
                                            className="fixed bottom-32 right-14 z-10 flex h-7 w-7  items-center justify-center rounded-full border-[0.5px] border-gray-alpha bg-gray-100 bg-opacity-50 md:h-9 md:w-9 md:bg-opacity-100 "
                                        >
                                            <img src={ArrowDown} alt="arrow down" className="h4- w-4 opacity-50 md:h-5 md:w-5" />
                                        </button>
                                    )} */}
                                                <Box sx={{ p: 3, pt: 0 }}>
                                                    {queries.length > 0 && (
                                                        <Grid item xs={12}>
                                                            {queries.map((query, index) => {
                                                                return (
                                                                    <Box key={index}>
                                                                        <ConversationBubble
                                                                            className={'mb-2'}
                                                                            key={`${index}QUESTION`}
                                                                            message={query.prompt?.substring(
                                                                                query.prompt?.indexOf('***') + 3,
                                                                                query.prompt?.lastIndexOf('***')
                                                                            )}
                                                                            type="QUESTION"
                                                                            sources={query.sources}
                                                                        ></ConversationBubble>
                                                                        {prepResponseView(query, index)}
                                                                    </Box>
                                                                );
                                                            })}
                                                            <span ref={scrollRefChat} />
                                                        </Grid>
                                                    )}
                                                    {queries.length === 0 && (
                                                        <ConversationBubble
                                                            ref={endMessageRef}
                                                            className="mb-2"
                                                            message="Xin chào, Tôi có thể giúp gì cho bạn hôm nay? 😊"
                                                            type={'GREETING'}
                                                            // sources={query.sources}
                                                            // feedback={query.feedback}
                                                            // handleFeedback={(feedback) => handleFeedback(query, feedback, index)}
                                                            // isTheLast={index === queries.length - 1}
                                                        ></ConversationBubble>
                                                    )}
                                                </Box>
                                            </CardContent>
                                        </Box>
                                    </PerfectScrollbar>
                                    <Grid container alignItems="center">
                                        <Grid
                                            item
                                            xs={12}
                                            padding={0}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <OutlinedInput
                                                multiline={true}
                                                size="small"
                                                // ref={inputRef}
                                                tabIndex={1}
                                                // fullWidth
                                                sx={{ width: '100%' }}
                                                autoFocus={false}
                                                // contentEditable
                                                // value={isRecording === true ? 'Đang nghe...' : message}
                                                value={message}
                                                onChange={(e) => {
                                                    setMessage(e.target.value);
                                                    setPrompt(false);
                                                }}
                                                // onPaste={handlePaste}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' && !e.shiftKey) {
                                                        e.preventDefault();
                                                        if (message && status !== 'loading') {
                                                            handleQuestion(message, template.model);
                                                            setMessage('');
                                                        }
                                                    }
                                                }}
                                                placeholder="Nhập tin nhắn của bạn ở đây..."
                                                aria-describedby="search-helper-text"
                                                inputProps={{ 'aria-label': 'weight' }}
                                            />
                                            {message === '' && status !== 'loading' && (
                                                <IconButton
                                                    sx={{ padding: '12px', paddingTop: '16px' }}
                                                    disabled
                                                    color="primary"
                                                    aria-label="send message"
                                                >
                                                    <SendTwoToneIcon />
                                                </IconButton>
                                            )}
                                            {status === 'loading' && <ClipLoader color="#156DA2" />}
                                            {message !== '' && status !== 'loading' && (
                                                <Tooltip title="Gửi tin nhắn" placement="top" arrow>
                                                    <IconButton
                                                        sx={{ padding: '12px', paddingTop: '16px' }}
                                                        color="primary"
                                                        onClick={(e) => {
                                                            if (message && status !== 'loading') {
                                                                handleQuestion(message, template.model);
                                                                setMessage('');
                                                            }
                                                        }}
                                                        aria-label="send message"
                                                    >
                                                        <SendTwoToneIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                    </Grid>
                </Stack>
            </Container>
        </MainCard>
    );
}
